import React, { Fragment, useEffect, useRef, useState } from 'react';
import SubmitButton from '../../components/submitButton';
import { useAsync } from 'react-async';
import { Redirect } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { sendLinkResetPassword } from '../../api/services/authService';
import { Link } from 'react-router-dom';
import { Notification } from '../../components/notifications';

const ForgotPassword = () => {
  const dispatch = useAppDispatch();

  // Refs
  const emailRef = useRef<HTMLInputElement>(null);

  // State
  const [emailAddress, setEmailAddress] = useState('');
  const [hasError, setHasError] = useState(false);
  const [saved, setSaved] = useState(false);

  const [sended, SetSended] = useState(false);
  const isProcessed = useAppSelector((s) => saved);

  useEffect(() => {
    let interval = setTimeout(() => {
      if (emailRef?.current) {
        let email = emailRef?.current?.value ?? '';

        setEmailAddress(email);

        clearInterval(interval);
      }
    }, 100);
  });

  const isValidEmail = () => {
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (!pattern.test(emailAddress)) {
      setHasError(true);
      return false;
    } else {
      setHasError(false);
      return true;
    }
  };

  const closeErrors = () => {
    setHasError(false);
  };

  const save = useAsync({
    deferFn: async () => {
      await sendLinkResetPassword({
        emailAddress: emailAddress,
        captchaToken: '',
      });
    },
    onResolve: () => {
      setSaved(true);
    },
    onReject: () => {
      setSaved(false);
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValidEmail()) {
      save.run();
    }
  };

  const toLogin = () => {
    SetSended(true);
  };

  const handleToLogin = () => {
    const timer = setTimeout(() => {
      dispatch(() => {
        toLogin();
      });
    }, 5000);
    return () => clearTimeout(timer);
  };
  if (isProcessed) {
    handleToLogin();
  }
  if (sended) {
    return <Redirect to='/' />;
  }

  return (
    <div className='flex bg-ptsblue-normal flex-col w-full items-center justify-center'>
      <div className='text-gray-900 w-full p-6 md:max-w-xl'>
        {hasError && (
          <Notification
            isSuccess={false}
            isOpen={hasError}
            onClose={closeErrors}
          >
            <Fragment>Please enter valid email address.</Fragment>
          </Notification>
        )}

        <form
          className='bg-white rounded-lg border shadow-lg p-10 mb-2'
          onSubmit={handleSubmit}
        >
          <div className='mb-4'>
            <label className='primary'>
              Verify your email associated with this site, and click on Enter:
            </label>
          </div>

          <div className='mb-4'>
            <input
              id='emailaddress'
              className='primary'
              onChange={(event) => setEmailAddress(event.target.value)}
              value={emailAddress}
              ref={emailRef}
              type='text'
              placeholder='Email Address'
            />
          </div>

          {saved && (
            <div className='mb-4'>
              <label className='primary'>
                Thanks. If your email address exists in our database, you will
                receive a password recovery link at your email address in a few
                minutes.
              </label>
            </div>
          )}

          <div className='flex items-center justify-between'>
            <SubmitButton spinning={save.isPending} text='Enter' />
            <Link to='/login'>&lt; Back to login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
